import { WifiOff } from "lucide-react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

/**
 * Global connectivity banner: while `navigator.onLine` is false a small pill
 * announces (role="status") that changes won't reach the server, so fetch
 * failures stop reading as generic errors. Mounted once in App.
 */
export function OfflineBanner() {
  const { t } = useTranslation();
  const [online, setOnline] = useState(() => navigator.onLine);

  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => {
      window.removeEventListener("online", on);
      window.removeEventListener("offline", off);
    };
  }, []);

  if (online) return null;

  return (
    <div className="fixed bottom-4 inset-x-0 z-[100] flex justify-center px-4 pointer-events-none">
      <div
        role="status"
        className="flex items-center gap-2 rounded-xl border border-warning/20 bg-warning-subtle px-4 py-2 text-sm font-medium text-warning-strong shadow-lg"
      >
        <WifiOff size={14} aria-hidden />
        {t("offline_banner")}
      </div>
    </div>
  );
}
